import { request } from "@/interface/helper";

const str = "gamerecommend";

export const gamerecommend = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/game/recommend/list" }),
    add: data => request({ data, method: "post", url: "/game/recommend/add" }),
    detail: data => request({ data, method: "post", url: "/game/recommend/detail" }),
    edit: data => request({ data, method: "post", url: "/game/recommend/modify" })
  }
};
